import React from 'react';
import { H4, P, Button, Flex, Modal, IconButton } from 'design-system-web';
import cs from 'classnames';

import styles from './ConfirmationModal.scss';
import { FONT_AWESOME_REGULAR } from 'lane-shared/helpers/constants/icons';

export function ConfirmationModal({
  isOpen,
  onClose,
  handleConfirm,
  title,
  description,
  cancelText,
  confirmText,
  testId,
  children,
  confirmActionDisabled = false,
  cancelActionDisabled = false,
  loading = false,
  isFullWidth = false,
}: {
  isOpen: boolean;
  onClose: Function;
  handleConfirm: Function;
  title: string;
  description?: string;
  cancelText: string;
  confirmText: string;
  testId?: string;
  children?: React.ReactNode;
  confirmActionDisabled?: boolean;
  cancelActionDisabled?: boolean;
  loading?: boolean;
  isFullWidth?: boolean;
}) {
  const hasDescription = Boolean(description);

  return (
    <Modal
      className={
        isFullWidth ? cs(styles.modal, styles.fullWidth) : styles.modal
      }
      isOpen={isOpen}
      onClose={() => onClose()}
      title={title}
      testId={testId}
      includeHeader={false}
      isCloseButtonHidden
      disableContentPadding
      disableCloseOnBackgroundClick={loading}
    >
      <Flex
        className={styles.modalHeader}
        justify="space-between"
        align="center"
      >
        <H4>{title}</H4>
        <IconButton
          type={FONT_AWESOME_REGULAR}
          onClick={() => onClose()}
          icon="times"
          data-test="closeButton"
          size="medium"
          disabled={loading}
        />
      </Flex>

      <Flex className={styles.modalBody} direction="column" gap={4}>
        {hasDescription && <P className={styles.Description}>{description}</P>}
        {children}
      </Flex>

      <hr className={styles.divider} />

      <Flex className={styles.modalActions} gap={3}>
        <Button
          variant="primary"
          size="large"
          onClick={() => handleConfirm()}
          disabled={confirmActionDisabled}
          loading={loading}
        >
          {confirmText}
        </Button>
        <Button
          variant="secondary"
          size="large"
          onClick={() => onClose()}
          disabled={cancelActionDisabled}
        >
          {cancelText}
        </Button>
      </Flex>
    </Modal>
  );
}
